"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightgalleryOsceResolve = void 0;
const lightgalleryRegex = /\[lightgallery([0-9]{0,})\]/;
function isOsceMarksheet(data) {
    return 'osceStationId' in data;
}
async function lightgalleryOsceResolve(data, cache) {
    let station;
    if (isOsceMarksheet(data)) {
        if (!data.osceStation) {
            throw new Error('OsceStation not found on OsceMarksheet');
        }
        station = data.osceStation;
    }
    else {
        station = data;
    }
    const upOsceStation = {
        candidateBrief: station.candidateBrief,
        actorBrief: station.actorBrief,
        examinerBrief: station.examinerBrief,
        explanation: station.explanation,
    };
    if (station.candidatePictures && station.candidatePictures.length > 0) {
        upOsceStation.candidateBrief = await lightgalleryMutation(upOsceStation.candidateBrief, station.candidatePictures, cache);
    }
    if (station.actorPictures && station.actorPictures.length > 0) {
        upOsceStation.actorBrief = await lightgalleryMutation(upOsceStation.actorBrief, station.actorPictures, cache);
    }
    if (station.examinerPictures && station.examinerPictures.length > 0) {
        upOsceStation.examinerBrief = await lightgalleryMutation(upOsceStation.examinerBrief, station.examinerPictures, cache);
    }
    if (station.walkthroughPictures && station.walkthroughPictures.length > 0) {
        upOsceStation.explanation = await lightgalleryMutation(upOsceStation.explanation, station.walkthroughPictures, cache);
    }
    if (isOsceMarksheet(data)) {
        return {
            ...data,
            osceStation: {
                ...data.osceStation,
                ...upOsceStation,
            },
        };
    }
    else {
        return {
            ...data,
            ...upOsceStation,
        };
    }
}
exports.lightgalleryOsceResolve = lightgalleryOsceResolve;
const lightgalleryMutation = async (text, pictures, cache) => {
    if (pictures.length === 0) {
        return text;
    }
    const picturesMdMap = {};
    for (const picture of pictures) {
        const pic = picture.path;
        const uri = `https://app.quesmed.com/${pic}`;
        let file = '';
        if (cache) {
            try {
                const localPath = await cache.CacheManager.get(uri, {}).getPath();
                if (localPath) {
                    file =
                        cache.Platform.OS === 'ios'
                            ? localPath.replace('file://', '')
                            : localPath;
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        let mdPic = `![${file}](${uri})`;
        if (picture.caption?.length > 0) {
            mdPic = `![${file}](${uri} "${picture.caption}")`;
        }
        if (!picturesMdMap[picture.index]) {
            picturesMdMap[picture.index] = [];
        }
        picturesMdMap[picture.index].push(mdPic);
    }
    const matches = text.matchAll(lightgalleryRegex);
    let matchExists = false;
    for (const match of matches) {
        const index = parseInt(match[1]);
        if (index === 0) {
            matchExists = true;
        }
        if (!picturesMdMap[index]) {
            // TODO: report to sentry or err that lightgallery pictures are missing
            continue;
        }
        const mdPics = picturesMdMap[index].join(' ');
        const lightgalleryTagToReplace = `[lightgallery${index > 0 ? index : ''}]`;
        text = text.replace(lightgalleryTagToReplace, mdPics);
    }
    if (!matchExists) {
        return text + '\n\n' + picturesMdMap[0].join(' ') + '\n';
    }
    return text;
};
